import { Component, computed, effect, HostBinding, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { css } from '@emotion/css';
import { Option } from '../../models/common.models';

@Component({
  selector: 'app-select',
  imports: [ReactiveFormsModule],
  templateUrl: './select.component.html',
  standalone: true,
})
export class SelectComponent {
  form = input<FormGroup>(new FormGroup({}));
  controlName = input<string>('');
  invalid = input<boolean>(false);
  options = input<Option[]>();
  placeholder = input<string>();
  disableWhenNoOptions = input<boolean>(true);
  blackText = input<boolean>(false);

  @HostBinding('class') className = css({ display: 'contents' });

  constructor() {
    effect(() => {
      const control = this.form().controls[this.controlName()];
      const options = this.options();
      const hasOptions = !!(options && options.length > 0);

      if (!control) {
        return;
      }

      if (
        control.value &&
        !(options || []).some((option) => option.value === control.value)
      ) {
        control.setValue('');
      }

      if (this.disableWhenNoOptions() && !hasOptions) {
        control.disable();
      } else {
        control.enable();
      }
    });
  }

  formClassName = css({ display: 'contents' });
  hasOptions = computed(() => !!this.options()?.length);

  selectClassName = computed(() =>
    css([
      {
        fontSize: 18,
        lineHeight: 18,
        borderRadius: 8,
        padding: 4,
        border: 'solid 1px #b3b3b3',
        flexGrow: 1,
        color: this.blackText() ? '#000' : undefined,

        '&.placeholder': {
          color: this.blackText()
            ? '#000'
            : 'color-mix(in srgb, currentColor 50%, transparent)',
        },

        '&:disabled': {
          cursor: 'not-allowed',
        },
      },
      this.invalid() && {
        borderColor: '#ED2121',
        boxShadow: '0px 0px 7px 2px rgba(237,33,33,0.85)',
      },
    ]),
  );
}
